<template>
  <div class="home_container">
    <!-- <page-top></page-top> -->
    <my-swiper :list="(_i18n.locale=='zh'?loopList:loopListEn)" ref="topSwiper"></my-swiper>
    <!-- <div class="content_wrap"> -->
    <expo-msg ref="contentRef"></expo-msg>
    <!-- </div> -->
    <!-- <page-bottom></page-bottom> -->
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageBottom from "@/components/pageBottom";
import pageFooter from "@/components/pageFooter";
import mySwiper from "@/components/mySwiper";
import expoMsg from "./expoMsg";
export default {
  components: {
    pageTop,
    pageBottom,
    mySwiper,
    expoMsg,
    pageFooter,
  },
  mounted() {
    // console.log(this.$route.query);
    let showHotel = localStorage.getItem("showHotel");
    localStorage.setItem("showHotel", this.$route.query.showHotel || showHotel);
    console.log(this._i18n.locale);
    
  },
  data() {
    return {
      loopListEn:[
      {
          id: "9",
          img: require("../../assets/img/banner7.jpg"),
        },
      ],
      loopList: [
        {
          id: "11",
          img: require("../../assets/img/banner5.jpg"),
        },
        // {
        //   id: "10",
        //   img: require("../../assets/img/banner6.jpg"),
        // },
        {
          id: "9",
          img: require("../../assets/img/banner4.jpg"),
        },

        // {
        //   id: "12",
        //   img: require("../../assets/img/banner2.png")
        // },
        // {
        //   id: "22",
        //   img: require("../../assets/img/banner1.png")
        // }
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.home_container {
  width: 100vw;
  // height: 2000px;
  // min-height: 100vh;
  background: #221f26;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: space-between;

  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (max-width: 1000px) {
  .menu_wrap {
    .right_wrap {
      visibility: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?f233f2f4